import React, { useContext, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { BsSearch } from 'react-icons/bs';
import { GrNotification } from 'react-icons/gr';
import Dropdown from 'react-bootstrap/Dropdown';
import '../assets/css/topbar.css';
import { IoIosLogOut } from "react-icons/io";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logOut, switchRole  } from '../store/user/actions/actionCreators';
import { FaBars } from "react-icons/fa6";
import { GlobalInfo } from '../App';
import { MdOutlineSwitchAccount } from "react-icons/md";  // ADD THIS ICON
import SportSwitcher from './SportSwitcher';

const TopBar = () => {
    const [showOptions, setShowOptions] = useState(false);
    const { isCollapsed, setIsCollapsed } = useContext(GlobalInfo)
    const navigate = useNavigate();
    const { user, token, currentRole  } = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const handleLogout = () => {
        dispatch(logOut(token, navigate));
    }

    const toggleDropdown = () => {
        setShowOptions(prev => !prev);
    }

    const handleRoleSwitch = (role) => {
        dispatch(switchRole(role, navigate));
        setShowOptions(false);
    }

      // Get available roles (excluding current role)
    //const availableRoles = user?.roles?.filter(role => role !== currentRole) || [];
    const availableRoles = user?.roles?.filter(role => role !== currentRole && role !== 'SUPER_ADMIN') || [];


    return (
        <Row className='bg-black'>
            <Col className='d-flex flex-coloumn align-items-center ps-3'>
                <div className='Fa-top-bars  ' onClick={() => setIsCollapsed(prev => !prev)} >
                    <FaBars color='black' size={20} cursor='pointer' />

                </div>
                {currentRole === 'ADMIN' && <SportSwitcher />}

            </Col>
            <Col className='px-0'>
                <div className='d-flex justify-content-end py-4 align-items-center'>

                    <div className="text-white me-3">{user?.email}</div>


                    <div className="custom-select-wrapper">
                        <Dropdown className={`user-dropdown`} show={showOptions} onToggle={toggleDropdown}>
                            <Dropdown.Toggle className='bar-icon' cursor='pointer' id="user-dropdown" />
                            <Dropdown.Menu className='p-2'>
                                {/* Show role switcher only if user has multiple roles */}
                                {availableRoles.length > 0 && (
                                    <>
                                        <Dropdown.Header>Switch Role</Dropdown.Header>
                                        {availableRoles.map((role) => (
                                            <Dropdown.Item 
                                                key={role}
                                                className="py-2" 
                                                onClick={() => handleRoleSwitch(role)}
                                            >
                                                <div className="d-flex align-items-center gap-2">
                                                    <MdOutlineSwitchAccount color='blue' fontSize={25} />
                                                    <span className='text-primary'>Switch to {role}</span>
                                                </div>
                                            </Dropdown.Item>
                                        ))}
                                        <Dropdown.Divider />
                                    </>
                                )}


                                <Dropdown.Item className="py-0" onClick={handleLogout}>
                                    <div className="text-decoration-none text-dark d-flex align-items-center gap-2">
                                        <IoIosLogOut color='red' fontSize={25} />
                                        <span className='text-danger'>Logout</span>
                                    </div>
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>
            </Col>
        </Row>
    );
}

export default TopBar;
